import Component from '../abstracts/Component';

export default class CollapseComponent extends Component {

  get COMPONENTNAME() {
    return 'CollapseComponent';
  }

  get SELECTORS() {
    return {
      collapse: '[data-collapse]',
      trigger: '[data-trigger]',
      tab: '[data-tab]',
      collapseBoxes: '[data-collapse-box]',
      collapseContent: '[data-collapse-content]',
      collapseTrigger: '[data-collapse-trigger]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.maxRes = this.$component.dataset.collapseMaxres;
    this.collapses = this.$component.querySelectorAll(this.SELECTORS.collapse);
    // globals
    this.collapseBoxes = document.querySelectorAll(this.SELECTORS.collapseBoxes);
    this.collapseTrigger = document.querySelectorAll(this.SELECTORS.collapseTrigger);
  }

  listenTrigger() {
    this.collapses.forEach((collapse, i) => {
      let trigger = collapse.querySelector(this.SELECTORS.trigger);
      if (trigger.getAttribute('data-trigger') != 'triggered' ) {
        trigger.addEventListener('click', () => this.handleTrigger(collapse, i));
        trigger.setAttribute('data-trigger','triggered');
        if (trigger.getAttribute('data-collapse-opened') != null && trigger.getAttribute('data-collapse-opened') == 'true') {
          // trigger the open
          trigger.click();
        }
      }
    });
  }

  handleTrigger(collapse, i) {
    this.collapses.forEach((item, index) => {
      if (index === i) {
        item.classList.toggle('collapsed');
      } else {
        item.classList.add('collapsed');
      }
    });
  }

  setCollapse() {
    this.collapses.forEach(collapse => {
      if (!collapse.classList.contains('collapsed')) {
        let tabs = collapse.querySelectorAll(this.SELECTORS.tab);
        tabs.forEach(tab => {
          let height = this.getHiddenHeight(tab);
          tab.style.maxHeight = `${height}px`;
        });
        collapse.classList.add('collapsed');
      }
    });
  }

  initCollapseMobile() {
    if (this.maxRes == 'md' && this.isTablet()) {
      this.setCollapse();
      this.listenTrigger();
    } else if (this.maxRes == 'sm' && this.isMobile()) {
      this.setCollapse();
      this.listenTrigger();
    }
  }


  initCollapse() {
    // add collapsed on collapsable boxes
    if (this.collapseBoxes != null) {
      this.collapseBoxes.forEach(collapse => {
        if (collapse.getAttribute('data-collapse-triggered') == null) {
          let contents = collapse.querySelectorAll(this.SELECTORS.collapseContent);
          contents.forEach(content => {
            let height = content.offsetHeight;
            content.style.maxHeight = `${height}px`;
          });
          collapse.classList.add('collapsed');
          collapse.setAttribute('data-collapse-triggered','');
        }
      });

    }
    // bind click
    if (this.collapseTrigger != null) {
      this.collapseTrigger.forEach((trigger, i) => {
        if (trigger.getAttribute('data-collapse-triggered') == null) {
          trigger.addEventListener('click', () => this.handleCollapseTrigger(trigger, i));
          trigger.setAttribute('data-collapse-triggered','');
          if (trigger.getAttribute('data-collapse-opened') != null && trigger.getAttribute('data-collapse-opened') == 'true') {
            // trigger the open
            trigger.click();
          }
        }
      });
    }
  }

  handleCollapseTrigger(trigger, i) {
    let target = document.querySelector('[data-collapse-box="'+trigger.getAttribute('data-collapse-trigger')+'"]');
    if (target != null) {
      target.classList.toggle('collapsed');
      target.classList.toggle('opened');
      trigger.classList.toggle('opened');

      console.log(trigger);
      console.log(trigger.dataset);
      if (trigger.dataset.collapseBodyclass != null) {
        document.body.classList.toggle(trigger.dataset.collapseBodyclass);
      }
    }
  }

  isTablet() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  bindEvents() {
    let ctx = this;
    // update the collapsed content
    this.$on(this.$customEvents.COLLAPSE_EVENTS.update, (e) => {
      let collapseContent = e.payload.extraDiv.closest(ctx.SELECTORS.collapseContent);
      collapseContent.style.maxHeight = 'none';
    });
  }

  render() {
    this.log('Rendering...');
    this.initCollapseMobile();
    this.initCollapse();
    this.bindEvents();
  }
}
